import { Navigation, Route } from '@ydegouvello/ui';
import { InitComponent } from 'components/init.component';
import { SessionsRepository } from 'repositories/sessions.repository';

export class InitRoute extends Route {
  private static _instance: InitRoute | undefined = undefined;

  private constructor(
    location: string,
    readonly sessionsRepository: SessionsRepository,
    readonly navigation: Navigation,
  ) {
    super(location);
  }

  static getInstance(
    location: string = '/*',
    sessionsRepository: SessionsRepository = SessionsRepository.getInstance(),
    navigation: Navigation = Navigation.getInstance(),
  ): InitRoute {
    this._instance ??= new this(location, sessionsRepository, navigation);
    return this._instance;
  }

  override async match(): Promise<boolean> {
    const session = await this.sessionsRepository.get();
    return !session;
  }

  override async getNewComponent(): Promise<InitComponent> {
    return InitComponent.getInstance();
  }
}
